<template>
  <div>
    <div slot="title">
      <h1>Consulta Personal</h1>
    </div>
    <div slot="main" v-if="AreaUsuario.AreaId==79">
      <div class="container-fluid area custom-area">
        <div class="row" style="margin-top:30px;">
          <div class="col-3">
            <label for="" class="label-black">Nombre(s) y/o Apellidos</label>
            <input
              type="text"
              class="form-control"
              placeholder="Nombre"
              v-model="nombreBusqueda"
              v-on:keyup.enter="buscarEvaluados"
            />
          </div>
          <div class="col-3">
            <label for="" class="label-black">No. de Nómina</label>
            <input
              type="text"
              class="form-control"
              placeholder="No. de Nómina"
              v-model="numeroNominaBusqueda"
              v-on:keyup.enter="buscarEvaluados"
            />
          </div>
          <div>
            <input type="checkbox" v-model="filtroPuesto" />
          </div>
          <div class="col-2">
            <span class="label label-default label-black">Tipo de Puesto</span>
          </div>
          <div class="col-2">
            <input
              type="button"
              value="Buscar"
              v-on:click="buscarEvaluados"
              class="form-control btn-custom"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6"></div>
          <div class="col-3"><hr /></div>
        </div>
        <div class="row">
          <div class="col-3"></div>
          <div class="col-3">
            <!-- <div
              class="alert alert-danger"
              role="alert"
              data-dismiss="alert"
              aria-label="Close"
              id="alertaNumeroNomina"
            >
              Valor no válido
            </div> -->
          </div>
          <div class="col-1" v-show="filtroPuesto">
            <input type="checkbox" v-model="interinoBusqueda" />
          </div>
          <div class="col-2" v-show="filtroPuesto">
            <span class="label label-default label-black">Interinato</span>
          </div>
        </div>
        <div class="row">
          <div class="col-6"></div>
          <div class="col-1" v-show="filtroPuesto">
            <input type="checkbox" v-model="deBaseBusqueda" />
          </div>
          <div class="col-2" v-show="filtroPuesto">
            <span class="label label-default label-black">Base</span>
          </div>
        </div>
        <div class="row">
          <div>
            <input type="checkbox" v-model="verInactivos" />
          </div>
          <div class="col-2" >
            <span class="label label-default label-black">Ver Personal Inactivo</span>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-12">
            <table
              class="table table-striped table-light table-hover table-sm"
              id="tablaPersonal"
            >
              <thead class="thead-custom">
                <tr>
                  <th>ID Persona</th>
                  <th>Nombre</th>
                  <th>Puesto</th>
                  <th>Departamento</th>
                  <th>Área</th>
                  <th>Tipo de Puesto</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody class="label-black">
                <tr v-for="infoPersona in infoPersonas">
                  <td>{{ infoPersona.PersonaId }}</td>
                  <td>{{ infoPersona.NombreCompleto }}</td>
                  <td>{{ infoPersona.Puesto }}</td>
                  <td>{{ infoPersona.Departamento }}</td>
                  <td>{{ infoPersona.Seccion }}</td>
                  <td>{{ infoPersona.TipoContratoDescripcion }}</td>
                  <td class="d-flex justify-content-around">
                    <i
                      class="fa fa-toggle-on"
                      v-if="infoPersona.Activo"
                      @click="pedirConfirmacion"
                      title="Desactivar Persona"
                    />
                    <i
                      class="fa fa-toggle-off"
                      v-if="!infoPersona.Activo"
                      @click="pedirConfirmacion"
                      title="Activar Persona"
                    ></i>
                    <i
                      class="fa fa-edit"
                      @click="editarUsuario(infoPersona.CURP)"
                      title="Editar Persona"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <h4>Descargar personal por área</h4>
        <hr />
        <div class="row">
          <div class="flex">
            <label for="" class="label-black">Área</label>
            <C001Area
              :prefijo="enumeraciones.etiquetasDeHTML.Select"
              :tipo="enumeraciones.tiposDeSelect.Todas"
              :idDelInput="'AreasBusquedaPersonal'"
              v-on:valorParaElPadre="CambioAreaBusqueda"
              :parametros="{}"
            ></C001Area>
            <input
              type="button"
              value="Descargar"
              v-on:click="DesacargarPersonalPorArea"
              class="btn btn-secondary"
              v-bind:disabled="this.comboAreaId <= 0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
             <h4 v-if="infoPersonas.length > 0">Resultados ({{infoPersonas.length}})</h4>
          <hr />
          </div>
        </div>
        <div
          class="modal fade"
          id="modalConfirmacion"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="tituloModalConfirmacion"></h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <h5>
                  <span
                    id="cuerpoModalConfirmacion"
                    class="col-form-label"
                  ></span>
                </h5>
                <br />
                <span class="col-form-label">¿Cual es el motivo?</span>
                <textarea
                  class="form-control"
                  id="motivoModalConfirmacion"
                ></textarea>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  id="botonModalConfirmacion"
                  data-dismiss="modal"
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="main" v-if="AreaUsuario.AreaId>0 && AreaUsuario.AreaId!=79">
      <div class="container-fluid area custom-area">
        <div class="row" style="margin-top:30px;">
            <div class="col-2 flex-parent jc-center label-black">
              <label>Nombre y/o Apellidos:</label>
            </div>
            <div class="col-4">
              
              <input
                type="text"
                class="form-control"
                placeholder="Nombre"
                v-model="nombreBusqueda"
                v-on:keyup.enter="buscarEvaluados"
              />
            </div>
            <div class="col-2 flex-parent jc-center label-black">
              <label>No. de Nómina:</label>
            </div>
            <div class="col-2">
              <input
                type="text"
                class="form-control"
                placeholder="No. de Nómina"
                v-model="numeroNominaBusqueda"
                v-on:keyup.enter="buscarEvaluados"
              />
            </div>
            <div class="col-2 flex-parent jc-center">
              <!-- <input type="button" value="Buscar" v-on:click="buscarEvaluados" class="form-control"  /> -->
              <button class="btn btn-sm btn-custom" @click='buscarEvaluados()'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Consultar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
            </div>
        </div>
        <br/>
        <div>
          <h4 v-if="infoPersonas.length > 0">Resultados ({{infoPersonas.length}})</h4>
          <hr />
        </div>
        <br/>
          <div id="tabla_Consulta" v-if="infoPersonas.length > 0">
            <table class="table table-striped table-light table-hover table-sm">
              <thead class="thead-custom">
                <tr>
                  <th>Nombre</th>
                  <th>Puesto</th>
                  <th>Departamento</th>
                  <th>Area</th>
                  <th>Tipo Puesto</th>
                </tr>
              </thead>
              <tbody class="label-black">
                <tr v-if="infoPersonas.length <= 0">
                  <td colspan="4" class="text-center">Sin Documentos para Envío a Sala de Lectura</td>
                </tr>
                <tr v-else v-for="Lista in infoPersonas" :key ="Lista.PersonaId" @click="ClickRow(Lista)">
                  <td style="cursor: pointer;">{{Lista.NombreCompleto}}</td>
                  <td>{{Lista.Puesto}}</td>
                  <td>{{Lista.Departamento}}</td>
                  <td>{{Lista.Seccion}}</td>
                  <td>{{Lista.TipoPlaza}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        <div v-if="mostrarModal">
          <Detalles :persona= this.transferirModal @dialogo='eventoModal($event)'></Detalles>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import catalogos from "@/../static/js/catalogos";
import comun from "@/../static/js/comun";
import enumeraciones from "@/../static/js/enumeraciones";
import api from "@/../static/js/api";
import axios from "axios";
import Vue from "vue";
import store from "@/store/index";
import modalDetalles from '@/components/SIAP/Comun/Modales/ModalConsulta.vue'

export default {
  data() {
    return {
      enumeraciones,
      filtroPuesto: false, //Verifica que el filtro de tipo de contrato esté activado
      boton: "", //Almacena el botón presionado para la Activación/Desactivación
      bandera: true, //Identifica si la acción que se quiere realizar es activación o desactivación
      nombreBusqueda: "", //Filtro de busqueda de nombre
      numeroNominaBusqueda: "", //Filtro de busqueda de número de nómina
      interinoBusqueda: false, //Filtro de busqueda para personal interino
      deBaseBusqueda: false, //Filtro de busqueda para personal de base
      infoPersonas: [],
      botonDescargarReporte: false, // botón de descarga del reporte de usuarios
      comboAreaId: null,
      comboAreaNombre: null,
      verInactivos: false,
      datosLocales: [
        {
          Id: 0,
          key: "area",
          valor: { Id: -1, nombre: null }
        }
      ],
      AreaUsuario: {
        AreaId: 0,
        Nombre: ""
      },
      mostrarModal : false,
      transferirModal : Object
      
    };
  },
  components: {
    C001Area: catalogos.PJ.C001Area,
    Detalles : modalDetalles
  },
  methods: {
    convertToCSV(objArray) {
      var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      var str = "";

      for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
          if (line != "") line += ",";
          line += array[i][index];
        }
        str += line + "\r\n";
      }
      return str;
    },

    exportCSVFile(headers, items, fileTitle) {
      if (headers) {
        items.unshift(headers);
      }

      // Convert Object to JSON
      var jsonObject = JSON.stringify(items);

      var csv = this.convertToCSV(jsonObject);

      var exportedFilenmae = fileTitle + ".csv" || "export.csv";

      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection

          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilenmae);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    // Inicia primera forma de exportar
    // exportToCsv(filename, rows) {
    //   var processRow = function (row) {
    //       var finalVal = '';
    //       for (var j = 0; j < row.length; j++) {
    //           var innerValue = row[j] === null ? '' : row[j].toString();
    //           if (row[j] instanceof Date) {
    //               innerValue = row[j].toLocaleString();
    //           };
    //           var result = innerValue.replace(/"/g, '""');
    //           if (result.search(/("|,|\n)/g) >= 0)
    //               result = '"' + result + '"';
    //           if (j > 0)
    //               finalVal += ',';
    //           finalVal += result;
    //       }
    //       return finalVal + '\n';
    //   };

    //   var csvFile = '';
    //   for (var i = 0; i < rows.length; i++) {
    //       csvFile += processRow(rows[i]);
    //   }

    //   var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    //   if (navigator.msSaveBlob) { // IE 10+
    //       navigator.msSaveBlob(blob, filename);
    //   } else {
    //       var link = document.createElement("a");
    //       if (link.download !== undefined) { // feature detection
    //           // Browsers that support HTML5 download attribute
    //           var url = URL.createObjectURL(blob);
    //           link.setAttribute("href", url);
    //           link.setAttribute("download", filename);
    //           link.style.visibility = 'hidden';
    //           document.body.appendChild(link);
    //           link.click();
    //           document.body.removeChild(link);
    //       }
    //   }
    // },
    // Termina segunda forma de exportar
    DesacargarPersonalPorArea() {      
      let peticion = {
        AreaId: this.comboAreaId
      };

      axios
        .post(
          api.conexion + api.SIAP.funcion.BuscarPersonaPorArea,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          console.log(response);
          if (response.data.SiHayError == false) {
            // console.log(response.data.Personas);

            let informacionDelDocumento = [];
            let cabecera = {
              nombre: "Nombre",
              apellidoPaterno: "Apellido Paterno",
              apellidoMaterno: "Apellido Materno",
              puesto: "Puesto",
              area: "Area"
            };

            response.data.Personas.forEach(persona => {
              // let areaAux = unescape(escape(persona.Seccion));
              // console.log(areaAux);

              informacionDelDocumento.push({
                nombre: persona.Nombre,
                apellidoPaterno: persona.ApellidoPaterno,
                apellidoMaterno: persona.ApellidoMaterno,
                puesto: persona.Puesto,
                area: persona.Seccion
              });
            });

            // console.log(informacionDelDocumento);

            // Primera forma de exportar
            this.exportCSVFile(
              cabecera,
              informacionDelDocumento,
              "exportacion"
            );

            //Segunda forma de exportar
            // this.exportToCsv("segundoMetodo.csv",informacionDelDocumento);
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    CambioAreaBusqueda(datos) {
      this.comboAreaId = parseInt(datos.target.value);
      this.comboAreaNombre =
        datos.target.options[datos.target.selectedIndex].text;
    },
    //busca a traves de axios el personal almacenado en base de datos
    buscarEvaluados: function(event) {
      $('#navtabla_Consulta').remove();

      if (this.numeroNominaBusqueda != "" && isNaN(this.numeroNominaBusqueda)) {
        $("#alertaNumeroNomina").show();
        return;
      }
      var peticion = {
        //Carga los valores para enviar la petición de busqueda
        esPrueba: false,
        nombreBusqueda: this.nombreBusqueda,
        numeroNominaBusqueda: parseInt(this.numeroNominaBusqueda, 10),
        tipoPuestoBusqueda: this.filtroPuesto,
        interinoBusqueda: this.interinoBusqueda,
        deBaseBusqueda: this.deBaseBusqueda,
        baneados: [],
        verInactivos: this.verInactivos,
        AreaId: this.datosLocales[0].valor.Id
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIAP.funcion.GetPersonas,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            $("#alertaNumeroNomina").hide();
            this.infoPersonas = response.data.InfoPersonas; //transifiere los datos necesarios
            if(this.infoPersonas.length<=0)
            {
              comun.mensajeDeAlerta("No hay Resultados que correspondan al criterio de busqueda", null, null);
            }
            //const rows = [];
            //this.infoPersonas.forEach(function (persona) {
            //  //persona.Contrasena = persona.Contrasena.split('#').join('gato');
            //  rows.push([persona.PersonaId, persona.Nombre, persona.ApellidoPaterno, persona.ApellidoMaterno, persona.NumeroNomina, persona.Puesto]);
            
            //});
            //let csvContent = "data:text/csv;charset=windows-1252," 
            //+ rows.map(e => e.join(",")).join("\n");
            //var encodedUri = encodeURI(csvContent);
            //window.open(encodedUri);
            //var encodedUri = encodeURI(csvContent);
            //var link = document.createElement("a");
            //link.setAttribute("href", encodedUri);
            //link.setAttribute("download", "my_data.csv");
            //document.body.appendChild(link); // Required for FF

            //link.click();
            this.mostrarTabla = true;
            this.$nextTick(() => {
              PaginarTabla("tablaPersonal", 10);
              PaginarTabla("tabla_Consulta", 10);
            });
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    editarUsuario: function(curpUsuario) {
      //Redirigeal usuario a la pantalla de editarusuario mandando como parametro el id de persona a editar
      this.$router.push({
        name: "AltaDeUsuario",
        params: { propCurp: curpUsuario }
      });
    },
    pedirConfirmacion: function(event) {
      //Abre un modal que solicita confirmación al momento de desactivar o cancelar la desactivación de un usuario
      this.boton = event.target;
      this.bandera = this.boton.className == "fa fa-toggle-off"; //Identifica si se quiere hacer una desactivacion o una cancelacion en base al tipo de boton
      var nombre = this.boton.parentElement.parentElement.cells[1].innerHTML; //Extrae el nombre de la persona a travez de la tabla
      var mensaje =
        "¿Está seguro de " +
        (this.bandera ? "activar" : "desactivar") +
        " el registro de " +
        nombre +
        "?";
      var titulo =
        "Confirmación de " + (this.bandera ? "activación" : "desactivación"); //Crea los mensajes del modal dependiendo de la acción a realizar
      $("#cuerpoModalConfirmacion").html(mensaje);
      $("#tituloModalConfirmacion").html(titulo);
      $("#botonModalConfirmacion").attr("disabled", true);
      $("#motivoModalConfirmacion").val("");
      $("#motivoModalConfirmacion").keyup(this.validarMotivo);
      $("#modalConfirmacion").modal();
      $("#botonModalConfirmacion")
        .unbind("click")
        .click(this.cambiarIcono); //Prepara las caracterisiticas de los elementos del modal
    },
    validarMotivo: function(event) {
      //Valida que el motivo de desactivación o cancelación sea capturado
      var cantidadTexto = $(event.target)
        .val()
        .trim().length;
      $("#botonModalConfirmacion").attr("disabled", cantidadTexto <= 0);
    },
    cambiarIcono: function() {
      //Obtiene el id de la persona a modificar
      var boton = this.boton;
      var bandera = this.bandera;
      var id = boton.parentElement.parentElement.childNodes[0].innerHTML;
      this.activarPersona(id, bandera);
    },
    activarPersona: function(id, bandera) {
      //Hace la llamada para modificar el estado de la persona en la base de datos
      //Carga los datos para hacer la petición
      var peticion = {
        esPrueba: false,
        idPersona: id,
        bandera: bandera
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(api.conexion + api.SIAP.funcion.SetActivoPersona, peticion)
        .then(response => {
          if (response.data.SiHayError == false) {
            var boton = this.boton;
            //En caso de que el cambio de estado sea exitoso, se modifica la apariencia del boton
            $(boton).toggleClass("fa-toggle-on");
            $(boton).toggleClass("fa-toggle-off");
            this.boton = null;
            this.bandera = true;
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    getValorEntidad(respuestaHijo) {
      this.datosLocales[0].valor = {
        Id: parseInt(respuestaHijo.target.value),
        nombre:
          respuestaHijo.target.options[respuestaHijo.target.selectedIndex].text
      };
    },
    ClickRow(dato)
    {
      this.transferirModal = dato;
      this.mostrarModal = true;
    },
    eventoModal(event){
      if (event.Salir==true)
      {
        this.mostrarModal = false;
      }
    }
  },
  mounted: function() {
    //$("#alertaNumeroNomina").hide(); //Oculta la alerta de error en Número de Nómina (para busqueda) al montar el componente
    if(this.$store.state.Login_Usuario.Area!=null)
    {
      this.AreaUsuario = this.$store.state.Login_Usuario.Area;
    }
    else
    {
      setTimeout(()=>{
        this.AreaUsuario = this.$store.state.Login_Usuario.Area;
      },3000)
    }
    
    // if(this.AreaUsuario.AreaId==79)
    // {
    //   $("#alertaNumeroNomina").hide(); //Oculta la alerta de error en Número de Nómina (para busqueda) al montar el componente
    // }
    //this.buscarEvaluados();
  }
};
</script>

<style scoped>
  .flex-parent {
  display: flex;
  }

.jc-center {
  justify-content: center;
  }
/* .sortable {
    cursor: pointer;
} */
.thead-custom {
  background-color: #004746;
  color: white;
}
.custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/AdministracionPersonal/ConsultaPersonal.vue